import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-cards",
    templateUrl: "./cards.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./cards.component.scss"]
})
export class CardsComponent {

}
